import React, { useState } from "react";
import CustomTooltip from "../../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faDownload,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "../../../../components/ui/use-toast";
import { ResponsiveDrawerForm } from "../../../../components/ResponsiveDrawerForm";
import moment from "moment";
import PolicyApproveModal from "./PolicyApproveModal";
import { Formik } from "formik";
import Spin from "../../../../components/Spin";
import { Label } from "../../../../components/ui/label";
import CustomLabelText from "../../../../components/CustomLabelText";
import MultiFileUpload from "../../../../components/MultiFileUpload";
import { Button } from "../../../../components/ui/button";
import { Textarea } from "../../../../components/ui/textarea";
import { API, fileUpload } from "../../../../config";
import { AddPolicySchema } from "../../../../lib/Validation";

const PolicyActionButton = ({
  id,
  approved,
  approvalPremission,
  fetchPolicies,
  item,
}) => {
  const [showApprove, setShowApprove] = useState(false);
  const [nextModal, setNextModal] = useState(false);
  const [reviewDate, setReviewDate] = useState(moment().add(1, "year"));
  const [complianceManagerId, setComplianceManagerId] = useState();
  const [loading, setLoading] = useState(false);

  const [showUpload, setShowUpload] = useState(false);

  const toggleUploadModal = () => {
    setShowUpload(!showUpload);
  };

  const toggleApproveModal = () => {
    setShowApprove(!showApprove);
  };

  const handleDownload = async (export_report_path) => {
    try {
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute("download", file[file.length - 1] || "file.pdf");
        a.setAttribute("target", "_blank");
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    } catch (e) {
      const errors = e.response?.data?.errors;
      toast({
        variant: "destructive",
        description: errors,
        duration: 3000,
      });
    }
  };

  const handlePolicyUpload = async (value) => {
    const formData = new FormData();

    formData.append(
      "file",
      value?.policy_file
        ? value?.policy_file?.[0]?.url
          ? value?.policy_file?.[0]?.url
          : value?.policy_file?.[0]?.file
        : "",
    );

    formData.append("_method", "put");

    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.POLICIES_ADD}${`/${id}`}`,
        formData,
      );
      setLoading(false);
      if (data) {
        toggleUploadModal();
        fetchPolicies();
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip
          message={item?.uploaded ? "Download Policy" : "Download Draft"}
        >
          <span>
            <FontAwesomeIcon
              onClick={() =>
                handleDownload(item?.uploaded ? item?.file : item?.draft_file)
              }
              icon={faDownload}
              size="1x"
              data-toggle="modal"
              data-target="#clientDetail"
            />
          </span>
        </CustomTooltip>
        {!approved ? (
          <>
            {item?.uploaded === 0 && (
              <>
                <span>/</span>
                <CustomTooltip message={"Upload"}>
                  <span>
                    <FontAwesomeIcon
                      onClick={() => toggleUploadModal()}
                      icon={faUpload}
                      size="1x"
                      data-toggle="modal"
                      data-target="#clientDetail"
                    />
                  </span>
                </CustomTooltip>
              </>
            )}
            {approvalPremission && item?.uploaded === 1 ? (
              <>
                <span>/</span>
                <CustomTooltip message={"Approve"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      size="1x"
                      onClick={() => {
                        toggleApproveModal();
                      }}
                    />
                  </span>
                </CustomTooltip>
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </span>
      {showApprove && (
        <ResponsiveDrawerForm
          description={""}
          title={"Approve Policy"}
          handleOpen={() => {}}
          handleClose={() => {
            setNextModal(false);
            setReviewDate(moment().add(1, "year"));
            setComplianceManagerId();
          }}
          popupType={"policies"}
          className="sm:max-w-1/2"
          open={showApprove}
          buttonClassName={""}
          setOpen={setShowApprove}
          mobileCancelHidden={true}
          confirmBox={true}
          write={true}
        >
          <PolicyApproveModal
            id={id}
            fetchPolicies={fetchPolicies}
            nextModal={nextModal}
            setNextModal={setNextModal}
            toggleApproveModal={toggleApproveModal}
            setReviewDate={setReviewDate}
            setComplianceManagerId={setComplianceManagerId}
            reviewDate={reviewDate}
            complianceManagerId={complianceManagerId}
          />
        </ResponsiveDrawerForm>
      )}

      {showUpload && (
        <ResponsiveDrawerForm
          description={""}
          title={"Upload Policy"}
          handleOpen={() => {}}
          handleClose={() => {}}
          className="sm:max-w-1/2"
          open={showUpload}
          popupType={"policies"}
          buttonClassName={""}
          setOpen={setShowUpload}
          mobileCancelHidden={true}
          confirmBox={true}
          write={true}
        >
          <Formik
            initialValues={{
              policy_file: [],
              reason: "",
            }}
            enableReinitialize={true}
            onSubmit={handlePolicyUpload}
            validateOnBlur={true}
            validateOnChange={true}
            validationSchema={AddPolicySchema}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
              isValid,
            }) => (
              <>
                {loading && <Spin expand={true} fullscreen={true} />}
                <form
                  onSubmit={handleSubmit}
                  noValidate
                  className="entry-section md:m-0 m-5"
                >
                  <div className="form-box overflow-y-auto overflow-x-hidden p-4 border rounded-lg">
                    <div className="grid gap-4">
                      <div className="grid gap-2">
                        <Label htmlFor="files">
                          <CustomLabelText
                            required={true}
                            labelText="Policy File"
                            errorField={errors?.policy_file}
                            bottomAlign={true}
                          />
                        </Label>
                        <MultiFileUpload
                          files={values?.policy_file}
                          setFiles={(data) => {
                            setFieldValue("policy_file", data);
                          }}
                          multiple={false}
                          accept=".pdf"
                        />
                        <div className="text-red-500 text-xs">
                          Please Upload PDF file only
                        </div>
                      </div>

                      <div className="grid gap-2">
                        <Label htmlFor="reason">
                          <CustomLabelText
                            labelText="Reason"
                            required={false}
                            errorField={errors?.reason}
                          />
                        </Label>
                        <Textarea
                          name="reason"
                          rows={4}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.reason}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
                    <Button type="submit" disabled={!isValid}>
                      Save
                    </Button>
                    <Button
                      className="reset ml-3"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleUploadModal();
                      }}
                      variant="secondary"
                    >
                      Cancel
                    </Button>
                  </div>
                </form>
              </>
            )}
          </Formik>
        </ResponsiveDrawerForm>
      )}
    </>
  );
};

export default PolicyActionButton;
